var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { PickType } from "@nestjs/swagger";
import { Type } from "class-transformer";
import { IsArray, IsBoolean, IsEnum, IsOptional, isURL, ValidateNested } from "class-validator";
import { asEnum, enumValues } from "./utils";
export var TefcaProvider;
(function (TefcaProvider) {
    TefcaProvider["CommonWell"] = "CommonWell";
    TefcaProvider["MedAllies"] = "MedAllies";
    TefcaProvider["HxTest"] = "HxTest";
})(TefcaProvider || (TefcaProvider = {}));
export function nonTestTefcaProviders() {
    return enumValues(TefcaProvider).filter((provider) => provider !== TefcaProvider.HxTest);
}
export var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["RO_PARTICLE_HEALTH"] = "RO_PARTICLE_HEALTH";
    FeatureFlag["RO_CLEAR_LOGIN_FALLBACK"] = "RO_CLEAR_LOGIN_FALLBACK";
    FeatureFlag["RO_EPIC_DIRECT"] = "RO_EPIC_DIRECT";
    FeatureFlag["RO_FASTEN_EPIC_LOOKUP"] = "RO_FASTEN_EPIC_LOOKUP";
    FeatureFlag["RO_PATIENT_PORTAL_SEARCH"] = "RO_PATIENT_PORTAL_SEARCH";
    FeatureFlag["RO_PATIENT_PORTAL_SEARCH_SUGGESTIONS"] = "RO_PATIENT_PORTAL_SEARCH_SUGGESTIONS";
    FeatureFlag["CLEAR_LOGIN_FALLBACK_RESET"] = "CLEAR_LOGIN_FALLBACK_RESET";
    FeatureFlag["DOCUMENT_RETRIEVAL_PATIENT_FLOW"] = "DOCUMENT_RETRIEVAL_PATIENT_FLOW";
    FeatureFlag["PATIENT_30_DAY_EXPIRATION_HEALTHEX_TOKEN"] = "PATIENT_30_DAY_EXPIRATION_HEALTHEX_TOKEN";
    FeatureFlag["DATA_DELIVERY_PATH_AS_FILENAME_PREFIX"] = "DATA_DELIVERY_PATH_AS_FILENAME_PREFIX";
    FeatureFlag["TEFCA_PROVIDERS"] = "TEFCA_PROVIDERS";
    FeatureFlag["ORG_TEFCA_PROVIDER"] = "ORG_TEFCA_PROVIDER";
    FeatureFlag["GLOBAL_ENABLED_TEFCA_PROVIDERS"] = "GLOBAL_ENABLED_TEFCA_PROVIDERS";
    FeatureFlag["HX_TEST_PATIENTS_ENABLED"] = "HX_TEST_PATIENTS_ENABLED";
    FeatureFlag["CLEAR_FORWARD_UPGRADE"] = "CLEAR_FORWARD_UPGRADE";
    FeatureFlag["ONLY_CLEAR_LOGIN_ALLOWED"] = "ONLY_CLEAR_LOGIN_ALLOWED";
    FeatureFlag["APPLE_LOGIN_BUTTON_ENABLED"] = "APPLE_LOGIN_BUTTON_ENABLED";
    FeatureFlag["COMMUNITY_AUTH"] = "COMMUNITY_AUTH";
    FeatureFlag["BACKGROUND_DATA_REFRESH"] = "BACKGROUND_DATA_REFRESH";
    FeatureFlag["TEST"] = "TEST";
    FeatureFlag["TEST2"] = "TEST2";
    FeatureFlag["TEST3"] = "TEST3";
    FeatureFlag["TEST4"] = "TEST4";
})(FeatureFlag || (FeatureFlag = {}));
export const nullDecoder = () => null;
const dateDecoder = (rawConfig) => {
    if (!rawConfig)
        return null;
    const date = new Date(rawConfig);
    return Number.isNaN(date.getTime()) ? null : date;
};
const createStringArrayDecoder = (enumType) => {
    const validValues = enumType ? new Set(Object.values(enumType)) : null;
    return (rawConfig) => {
        if (!rawConfig)
            return null;
        try {
            const parsed = JSON.parse(rawConfig);
            if (!Array.isArray(parsed))
                return null;
            const isValidItem = (item) => typeof item === "string" && (!validValues || validValues.has(item));
            if (!parsed.every(isValidItem))
                return null;
            return parsed;
        }
        catch {
            return null;
        }
    };
};
const createURLArrayDecoder = () => {
    return (rawConfig) => {
        if (!rawConfig)
            return null;
        try {
            const parsed = JSON.parse(rawConfig);
            if (!Array.isArray(parsed))
                return null;
            const isValidItem = (item) => typeof item === "string" && isURL(item, { protocols: ["http", "https"], require_tld: false, require_protocol: true });
            if (!parsed.every(isValidItem))
                return null;
            return parsed;
        }
        catch {
            return null;
        }
    };
};
const backgroundDataRefreshDecoder = (rawConfig) => {
    var _a, _b;
    if (!rawConfig)
        return null;
    try {
        const parsed = JSON.parse(rawConfig);
        if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed))
            return null;
        const result = {};
        const minimumDaysSinceLastRetrieval = (_a = Object.getOwnPropertyDescriptor(parsed, "minimumDaysSinceLastRetrieval")) === null || _a === void 0 ? void 0 : _a.value;
        const maximumSetSize = (_b = Object.getOwnPropertyDescriptor(parsed, "maximumSetSize")) === null || _b === void 0 ? void 0 : _b.value;
        if (typeof minimumDaysSinceLastRetrieval === "number")
            result.minimumDaysSinceLastRetrieval = minimumDaysSinceLastRetrieval;
        if (typeof maximumSetSize === "number")
            result.maximumSetSize = maximumSetSize;
        return result;
    }
    catch {
        return null;
    }
};
const createEnumDecoder = (enumType) => {
    return (rawConfig) => {
        if (!rawConfig)
            return null;
        return asEnum(enumType)(rawConfig);
    };
};
const roEpicDirectDecoder = (rawConfig) => {
    var _a, _b, _c, _d, _e;
    if (!rawConfig)
        return null;
    try {
        const parsed = JSON.parse(rawConfig);
        if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed))
            return null;
        const result = {};
        const filterEpicFromFasten = (_a = Object.getOwnPropertyDescriptor(parsed, "filterEpicFromFasten")) === null || _a === void 0 ? void 0 : _a.value;
        const fastenUsefulScoreThreshold = (_b = Object.getOwnPropertyDescriptor(parsed, "fastenUsefulScoreThreshold")) === null || _b === void 0 ? void 0 : _b.value;
        const epicUsefulScoreThreshold = (_c = Object.getOwnPropertyDescriptor(parsed, "epicUsefulScoreThreshold")) === null || _c === void 0 ? void 0 : _c.value;
        const useLogoCache = (_d = Object.getOwnPropertyDescriptor(parsed, "useLogoCache")) === null || _d === void 0 ? void 0 : _d.value;
        const debug = (_e = Object.getOwnPropertyDescriptor(parsed, "debug")) === null || _e === void 0 ? void 0 : _e.value;
        if (typeof filterEpicFromFasten === "boolean")
            result.filterEpicFromFasten = filterEpicFromFasten;
        if (typeof fastenUsefulScoreThreshold === "number")
            result.fastenUsefulScoreThreshold = fastenUsefulScoreThreshold;
        if (typeof epicUsefulScoreThreshold === "number")
            result.epicUsefulScoreThreshold = epicUsefulScoreThreshold;
        if (typeof useLogoCache === "boolean")
            result.useLogoCache = useLogoCache;
        if (typeof debug === "boolean")
            result.debug = debug;
        return result;
    }
    catch {
        return null;
    }
};
export const featureFlagConfigTypeMap = {
    [FeatureFlag.RO_PARTICLE_HEALTH]: nullDecoder,
    [FeatureFlag.RO_CLEAR_LOGIN_FALLBACK]: nullDecoder,
    [FeatureFlag.RO_EPIC_DIRECT]: roEpicDirectDecoder,
    [FeatureFlag.RO_FASTEN_EPIC_LOOKUP]: nullDecoder,
    [FeatureFlag.RO_PATIENT_PORTAL_SEARCH]: nullDecoder,
    [FeatureFlag.RO_PATIENT_PORTAL_SEARCH_SUGGESTIONS]: nullDecoder,
    [FeatureFlag.DOCUMENT_RETRIEVAL_PATIENT_FLOW]: nullDecoder,
    [FeatureFlag.PATIENT_30_DAY_EXPIRATION_HEALTHEX_TOKEN]: nullDecoder,
    [FeatureFlag.DATA_DELIVERY_PATH_AS_FILENAME_PREFIX]: nullDecoder,
    [FeatureFlag.HX_TEST_PATIENTS_ENABLED]: nullDecoder,
    [FeatureFlag.TEST]: nullDecoder,
    [FeatureFlag.CLEAR_LOGIN_FALLBACK_RESET]: dateDecoder,
    [FeatureFlag.TEST2]: dateDecoder,
    [FeatureFlag.TEST3]: createStringArrayDecoder(),
    [FeatureFlag.TEST4]: createStringArrayDecoder(TefcaProvider),
    [FeatureFlag.TEFCA_PROVIDERS]: createStringArrayDecoder(TefcaProvider),
    [FeatureFlag.ORG_TEFCA_PROVIDER]: createEnumDecoder(TefcaProvider),
    [FeatureFlag.GLOBAL_ENABLED_TEFCA_PROVIDERS]: createStringArrayDecoder(TefcaProvider),
    [FeatureFlag.CLEAR_FORWARD_UPGRADE]: nullDecoder,
    [FeatureFlag.ONLY_CLEAR_LOGIN_ALLOWED]: nullDecoder,
    [FeatureFlag.APPLE_LOGIN_BUTTON_ENABLED]: nullDecoder,
    [FeatureFlag.COMMUNITY_AUTH]: createURLArrayDecoder(),
    [FeatureFlag.BACKGROUND_DATA_REFRESH]: backgroundDataRefreshDecoder,
};
export class Feature {
    constructor(fields) {
        if (fields) {
            Object.assign(this, fields);
        }
    }
    decodeConfiguration() {
        try {
            return featureFlagConfigTypeMap[this.feature](this.configuration);
        }
        catch (error) {
            return null;
        }
    }
}
__decorate([
    IsEnum(FeatureFlag)
], Feature.prototype, "feature", void 0);
__decorate([
    IsBoolean()
], Feature.prototype, "enabled", void 0);
__decorate([
    IsOptional()
], Feature.prototype, "configuration", void 0);
export class FeatureUpdateInput extends PickType(Feature, ["feature", "enabled", "configuration"]) {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
export class FeaturesDto {
}
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => Feature)
], FeaturesDto.prototype, "features", void 0);
